import type { TFunction } from 'i18next'

import type { ResourceJsonErrorCode } from '@/features/resource/configuration/endpoints/resourceJsonConfiguration'

const KNOWN_CODES: readonly ResourceJsonErrorCode[] = [
  'NOT_BATTERY',
  'NOT_LOCAL_CONTROL',
  'MULTIPLE_CONTROLLERS',
  'NO_EQUIPMENT_NUMBER',
  'CONTROLLER_NOT_FOUND',
] as const

export function isResourceJsonErrorCode(value: unknown): value is ResourceJsonErrorCode {
  return typeof value === 'string' && (KNOWN_CODES as readonly string[]).includes(value)
}

export function resourceJsonErrorMessage(code: ResourceJsonErrorCode, t: TFunction<'translation'>): string {
  switch (code) {
    case 'NOT_BATTERY':
      return t('resources.configuration.error.not_battery')
    case 'NOT_LOCAL_CONTROL':
      return t('resources.configuration.error.not_local_control')
    case 'MULTIPLE_CONTROLLERS':
      return t('resources.configuration.error.multiple_controllers')
    case 'NO_EQUIPMENT_NUMBER':
      return t('resources.configuration.error.no_equipment_number')
    case 'CONTROLLER_NOT_FOUND':
      return t('resources.configuration.error.controller_not_found')
  }
}

export function extractResourceJsonErrorCode(responseData: unknown): ResourceJsonErrorCode | null {
  if (responseData && typeof responseData === 'object' && 'code' in responseData) {
    const code = (responseData as { code: unknown }).code
    return isResourceJsonErrorCode(code) ? code : null
  }
  return null
}
